/**
 * Task SC: commission for membership subscriptions (订阅), responsible staff (负责人), failed-payment pay link,
 * improved subscriptions list. One row per key: [key, English, 中文] — English + 中文 only (Bahasa Malaysia was
 * removed as a product language; the ms dictionary falls back to English). Registered in ../modules.ts.
 */
const ROWS = [
  ["payroll.type.subscription", "Subscription", "订阅"],
  ["sc.pay.label", "Pays on", "计算方式"],
  ["sc.pay.first", "First payment only", "首次付款"],
  ["sc.pay.every", "Every successful payment (incl. renewals)", "每次付款成功（含续费）"],
  ["sc.plan.help", "Subscription rules pay the subscription's responsible staff (负责人) on the amount the customer actually paid (gross — before Senvia's service fee and Stripe fees; refunds are taken back). Renewals need no bill: each successful payment creates the commission automatically.", "订阅规则的提成归该订阅的负责人，按顾客实际支付金额计算（毛额：未扣 Senvia 服务费与 Stripe 手续费；退款会自动冲回）。续费无需开单：每次付款成功自动产生提成。"],
  ["sc.planCommissionHelp", "Only used while your commission plan has no 订阅 / Subscription rule (Payroll → Commission plan). Commission always goes to the subscription's responsible staff.", "仅在提成方案中没有「订阅」规则时使用（工资 → 提成方案）。提成始终归订阅的负责人。"],
  ["sc.seller", "Responsible staff", "负责人"],
  ["sc.seller.none", "Not assigned", "未指定"],
  ["sc.seller.change", "Change", "更改"],
  ["sc.seller.help", "Earns the commission of every future payment of this subscription (renewals included — no bill needed). A change applies to future payments only.", "此订阅之后每次付款的提成都归负责人（含续费，无需开单）。更改只影响之后的付款。"],
  ["sc.seller.saved", "Responsible staff updated", "负责人已更新"],
  ["sc.seller.online", "Signed up online — assign a responsible staff if someone should get the commission.", "顾客在线自助开通 — 如需计提成，请指定负责人。"],
  ["sc.f.active", "Active", "生效中"],
  ["sc.f.trialing", "Trial", "试用中"],
  ["sc.f.past_due", "Payment failed", "付款失败"],
  ["sc.f.cancelling", "Cancelling", "取消中"],
  ["sc.f.ended", "Ended", "已结束"],
  ["sc.f.all", "All", "全部"],
  ["sc.filter.anyStaff", "All staff", "全部负责人"],
  ["sc.filter.anyPlan", "All plans", "全部方案"],
  ["sc.filter.search", "Search customer", "搜索顾客"],
  ["sc.col.amount", "Amount", "金额"],
  ["sc.col.next", "Next charge", "下次扣款"],
  ["sc.col.last", "Last payment", "上次付款"],
  ["sc.col.actions", "Actions", "操作"],
  ["sc.last.paid", "Paid {date}", "已付 {date}"],
  ["sc.last.failed", "Failed {date}", "失败 {date}"],
  ["sc.last.open", "Due", "待付款"],
  ["sc.last.retry", "Stripe retries {date}", "Stripe 将于 {date} 重试"],
  ["sc.badge.failed", "Payment failed", "付款失败"],
  ["sc.act.payLink", "Resend pay link", "重发付款链接"],
  ["sc.act.call", "Call", "致电"],
  ["sc.act.wa", "WhatsApp", "WhatsApp"],
  ["sc.act.sent", "Pay link sent to {name}", "付款链接已发送给 {name}"],
  ["sc.act.copy", "Copy link", "复制链接"],
  ["sc.act.copied", "Link copied", "链接已复制"],
  ["sc.act.linkSent", "Link sent {date}", "已发送链接 {date}"],
  ["sc.export", "Export CSV", "导出 CSV"],
  ["sc.payNow", "Pay-now link", "付款链接"],
  ["sc.retry.help", "When a renewal payment fails, Stripe retries automatically using your own Stripe settings (Smart Retries — by default about 4 tries over 2–3 weeks; change it in your Stripe dashboard → Billing → Revenue recovery). The customer gets a message with a link to pay now or use another card, and you are notified once per failed payment. If every retry fails, the subscription ends.", "续费扣款失败时，Stripe 会按您自己的 Stripe 设置自动重试（Smart Retries，默认约 2–3 周内重试 4 次；可在 Stripe 后台 → Billing → Revenue recovery 中更改）。顾客会收到一条附有付款链接的消息，可立即付款或换卡；每笔失败的付款只通知您一次。所有重试都失败后，订阅会结束。"],
  ["sc.csv.status", "Status", "状态"],
] as const;

export type ScKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<ScKey, string>;

export const taskSC = { en: col(1), zh: col(2), ms: col(1) };
